import { makeStyles, tokens } from '@fluentui/react-components';

export const useTenantRoleSectionStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    paddingBlock: tokens.spacingVerticalL,
  },

  header: {
    display: 'flex',
    alignItems: 'baseline',
    gap: tokens.spacingHorizontalS,
  },

  roleLabel: {
    margin: '0',
    color: tokens.colorNeutralForeground1,
  },

  groupCount: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
  },

  groupList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalXS,
  },
});
